<template>
  <div
    v-if="api"
    class="dn-ticker-markets"
  >
    <div class="container">
      <slot
        class="dn-ticker__prefix"
        name="prefix"
      />

      <div
        v-if="hasTickerItems"
        class="item-content"
      >
        <div
          v-for="product in products"
          :key="product?.symbol"
          class="item"
        >
          <template v-if="product?.symbol">
            <label
              v-if="getTickerItem(product.symbol)"
              class="item-name"
            >
              {{ product.name }}
            </label>

            <div class="item-holder">
              <span
                v-if="getTickerItem(product.symbol)"
                class="item-value"
              >
                {{ getTickerItem(product.symbol)?.toLocaleString() }}
              </span>
            </div>
          </template>
        </div>

        <dn-link
          :external="true"
          :text="suffix?.text"
          :href="suffix?.url"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Ref } from 'vue';

const props = defineProps({
  investorTicker: {
    type: Object,
    required: true,
    default: () => ({})
  }
});
const appEnv = useRuntimeConfig().public?.appEnv || 'prod';
const api = props.investorTicker?.[`${appEnv}Api`];
const products = props.investorTicker.products || [];
const suffix = props.investorTicker?.suffix || {};
const { query } = useTansQuery();
const tickerItems = ref<Record<string, number>>({});
const hasTickerItems = computed(() => Object.keys(tickerItems.value).length > 0);

function getTickerItem (symbol: string): number | undefined {
  return tickerItems.value?.[symbol];
}

onBeforeMount(() => {
  const { data } = query({
    api: ref(api),
    enabled: ref(true),
    type: 'dn-ticker-markets',
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  }) as { data: Ref<Record<string, number> | undefined> };

  watch(data, (newVal) => {
    if (newVal) {
      tickerItems.value = newVal ?? {};
    }
  },
  {
    immediate: true
  });
});
</script>

<style scoped lang="scss">
.dn {
  &-ticker {
    &-markets {
      --dn_font-size: 14px;
      --dn-link_font-size: 14px;
      --dn_line-height: 14px;

      min-height: 48px;

      .container {
        gap: var(--ui-gap);

        @media only screen and (width >= 980px) {
          --header-width: auto;
        }
      }

      .item {
        --dn_font-family: var(--typography-utility-s-font-family);
        --dn_font-weight: 700;

        align-items: center;

        &:not(:last-child) {
          border-right: 1px solid var(--color-investor-fg);
        }

        &-content {
          gap: var(--ui-gap);
          font-variant-numeric: tabular-nums;
        }

        &-holder {
          padding: 0 var(--ui-gap) 0 8px;
        }

        &-value {
          --dn_color: var(--color-button-primary-inverted-active-bg);

          font-weight: 400;
        }
      }
    }
  }
}
</style>
